export default {
  logout: () => "logout",
}
